import Button from "tds/button";

export { Button };

customElements.define("tds-button", Button.CustomElementConstructor);
